import {
  DashboardChartsRow,
  FinancialOverviewChart,
  type ChartDatum,
} from "@/components/dashboard";
import DeliveryProfileChart from "./DeliveryProfileChart";

type FmbChartsRowProps = {
  financialData: ChartDatum[];
  deliveryProfileData: { name?: string; value?: number; color?: string }[];
};

export default function FmbChartsRow({ financialData, deliveryProfileData }: FmbChartsRowProps) {
  return (
    <DashboardChartsRow
      primary={
        <FinancialOverviewChart
          data={financialData}
          title="Income, vendor expenses & commitments"
        />
      }
      secondary={<DeliveryProfileChart data={deliveryProfileData} />}
    />
  );
}
